import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Navigation from './portfoliov2/components/Navigation/Navigation';
import Hero from './portfoliov2/components/Hero/Hero';
import Projects from './portfoliov2/components/Projects/Projects';
import Blog from './portfoliov2/components/Blog/Blog';
import Skills from './portfoliov2/components/Skills/Skills';
import Experience from './portfoliov2/components/Experience/Experience';
import Contact from './portfoliov2/components/Contact/Contact';
import metadata from '../metadata.json';
import { usePageTracking, useScrollTracking, useAnalytics } from './hooks/useAnalytics';
const packageVersion = metadata.version;
const GlobalStyle = createGlobalStyle `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    background: #ffffff;
    color: #1a1a1a;
    line-height: 1.6;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: inherit;
  }

  #root {
    width: 100%;
  }
`;
const AppWrapper = styled.div `
  width: 100%;
`;
const AppVersion = styled.div `
    font-size: 10px;
    padding: 4px;
`;
const Appv2 = () => {
    const [activeSection, setActiveSection] = useState('home');
    const [isClient, setIsClient] = useState(false);
    // Track page view and scroll depth
    usePageTracking('Portfolio Home', 'Raja Kedia - Portfolio');
    useScrollTracking();
    const { trackSectionView } = useAnalytics();
    useEffect(() => {
        // Mark as client-side rendered to avoid hydration mismatches
        setIsClient(true);
    }, []);
    useEffect(() => {
        // Only run on client side
        if (typeof window === 'undefined')
            return;
        let lastTrackedSection = '';
        // Track active section on scroll
        const handleScroll = () => {
            const sections = ['home', 'projects', 'blog', 'skills', 'experience', 'contact'];
            for (const section of sections) {
                if (section === 'home') {
                    if (window.scrollY < 100) {
                        setActiveSection('home');
                        if (lastTrackedSection !== 'home') {
                            trackSectionView('home');
                            lastTrackedSection = 'home';
                        }
                        break;
                    }
                }
                else {
                    const element = document.getElementById(section);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                            setActiveSection(section);
                            if (lastTrackedSection !== section) {
                                trackSectionView(section);
                                lastTrackedSection = section;
                            }
                            break;
                        }
                    }
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [trackSectionView]);
    const handleBlogClick = (postId) => {
        console.log('Blog post clicked:', postId);
        // Later: navigate to blog post detail page
        // router.push(`/blog/${postId}`);
    };
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _jsxs(AppWrapper, { children: [_jsx(Navigation, { activeSection: activeSection }), _jsx(Hero, {}), _jsx(Projects, {}), _jsx(Blog, { onBlogClick: handleBlogClick }), _jsx(Skills, {}), _jsx(Experience, {}), _jsx(Contact, {})] }), _jsxs(AppVersion, { children: ["Version: ", packageVersion] })] }));
};
export default Appv2;
